import { makeDecodeURL } from '@shared/helpers/makeDecodeURL';

export const saveFile = async (url: string, name: string) => {
    // @ts-ignore
    await loader.show();
    await fetch(url)
        .then((response) => {
            if (!response.ok) {
                // @ts-ignore
                throw new Error(i18next.t('saveFile.fetch.then.return.response.throw'));
                // @ts-ignore
                loader.hide();
            }
            const contentDisposition = response.headers.get('Content-Disposition');

            const extraName = makeDecodeURL(name, true);

            let filename = extraName || 'downloaded_file_name.ext';
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (filenameMatch.length === 2) {
                    filename = filenameMatch[1];
                }
            }
            // @ts-ignore
            loader.hide();
            return response.blob().then((blob) => ({ blob, filename }));
        })
        .then(({ blob, filename }) => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
            // @ts-ignore
            swal({
                // @ts-ignore
                text: `${i18next.t('saveFile.fetch.catch.return.swal.text')}`,
                cancel: false,
                confirm: true,
                button: {
                    // @ts-ignore
                    text: `${i18next.t('saveFile.fetch.catch.return.swal.button.text')}`,
                    value: true,
                    visible: true,
                    className: 'btn btn-light',
                },
            });
            // @ts-ignore
            loader.hide();
        });
};
